import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { motion } from 'framer-motion';
import { usePageTransition } from '../../utils/pageTransitions';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import ContactHero from './components/ContactHero';
import ContactInfo from './components/ContactInfo';
import ContactForm from './components/ContactForm';
import WhatsAppFloat from './components/WhatsAppFloat';
import FAQSection from './components/FAQSection';

const Contact = () => {
  const { variants, transition } = usePageTransition();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Contactez-nous - ORAZEK Investment</title>
        <meta name="description" content="Contactez notre équipe à Kinshasa pour tous vos projets. Devis gratuit, support client 24/7. Téléphone, WhatsApp ou Email." />
      </Helmet>
      <div className="min-h-screen bg-white dark:bg-slate-900">
        <Header />
        <motion.main
          className="main-content"
          initial="initial"
          animate="animate"
          exit="exit"
          variants={variants}
          transition={transition}
        >
          <ContactHero />
          <ContactInfo />
          <ContactForm />
          <FAQSection />
        </motion.main>
        <Footer />
        <WhatsAppFloat />
      </div>
    </>
  );
};

export default Contact;